import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TwoColumn } from 'components/layout'
import { Button } from 'components/buttons'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { ApproversTable } from '@features/admin/features/approval-domain-approvers'

interface ApproversSectionProps {
  project: AdminProject
  onAdd: () => void
  onEdit: (approver: Approver) => void
  onDelete: (approver: Approver) => void
}

export const ApproversSection: FC<ApproversSectionProps> = ({
  project,
  onAdd,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation()

  return (
    <TwoColumn
      label={t('common.approvers')}
      description={t(
        'features.projectsAdmin.projectDetails.approversDescription',
      )}
      leftSlot={
        <Button onClick={onAdd} icon={faPlus} className="text-sm">
          {t('features.approvalDomainApprovers.addApprovers')}
        </Button>
      }
    >
      <ApproversTable
        approvalDomainId={project.globalId}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </TwoColumn>
  )
}
